import React from 'react';
import { Footer } from '../components/Footer';
import { SubpageNav } from '../components/SubpageNav';
import { SubpageCTA } from '../components/SubpageCTA';
import { OmMigHero } from '../components/om-mig/OmMigHero';
import { OmMigSummary } from '../components/om-mig/OmMigSummary';
import { OmMigSkills } from '../components/om-mig/OmMigSkills';
import { OmMigAssignments } from '../components/om-mig/OmMigAssignments';
import { OmMigPersonal } from '../components/om-mig/OmMigPersonal';
import { ctaPersonas } from '../data/om-mig-data';
export function OmMig() {
  return <div className="min-h-screen bg-background text-ink font-sans" data-id="element-375">
      <SubpageNav activePage="om-mig" data-id="element-376" />

      <main className="pt-20" data-id="element-377">
        <OmMigHero data-id="element-378" />
        <OmMigSummary data-id="element-379" />
        <OmMigSkills data-id="element-380" />
        <OmMigAssignments data-id="element-381" />
        <OmMigPersonal data-id="element-382" />
        <SubpageCTA badgeText="Helt utan förpliktelser" badgeColor="terracotta" heading="Vad är din anledning att höra av dig?" subheading="Det finns inget rätt skäl. Alla samtal börjar någonstans — och de flesta börjar med en enkel fråga." personas={ctaPersonas} backLinkText="Tillbaka till startsidan" backLinkUrl="/" data-id="element-383" />
      </main>
      <Footer data-id="element-384" />
    </div>;
}